import {
  GUTTER_SIZE,
  INTERNAL_GUTTER_NUMBER,
  ROW_COL_SPAN,
} from '@modules/dashboard/constants';

export function getColWidth(rowWidth: number): number {
  const totalColWidth = rowWidth - GUTTER_SIZE * INTERNAL_GUTTER_NUMBER;

  return totalColWidth / ROW_COL_SPAN;
}
